import { SVGProps, memo } from 'react';
import PDFIcon from '../assets/images/pdf.png';

const PdfIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}
  >
    <rect width='24' height='24' fill='url(#pattern0_5450_80040)' />
    <defs>
      <pattern
        id='pattern0_5450_80040'
        patternContentUnits='objectBoundingBox'
        width='1'
        height='1'
      >
        <use
          xlinkHref='#image0_5450_80040'
          transform='matrix(0.0263158 0 0 0.025641 -0.184211 -0.153846)'
        />
      </pattern>
      <image
        id='image0_5450_80040'
        width='54'
        height='48'
        preserveAspectRatio='none'
        xlinkHref={PDFIcon}
      />
    </defs>
  </svg>
);

export default memo(PdfIcon);
